export const LEVELING_AGENT_MESSAGE_TYPES = {
  HUMAN: 'human',
  AI: 'ai',
  TOOL: 'tool',
};

export const LEVELING_AGENT_MESSAGE_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const LEVELING_AGENT_WRITE_TOOLS = [
  'create_full_framework',
  'create_track',
  'create_level',
  'update_level',
  'delete_level',
];

export const LEVELING_AGENT_TOOL_TYPES = {
  DISCOVERY: 'discovery',
  REASONING: 'reasoning',
  READ: 'read',
  WRITE: 'write',
};

export const LEVELING_AGENT_TOOL_CALL_STATUSES = {
  PENDING: 'pending',
  ERROR: 'error',
  COMPLETED: 'completed',
};

export const LEVELING_AGENT_TOOL_REGISTRY = {
  mark_discovery_complete: {
    type: LEVELING_AGENT_TOOL_TYPES.DISCOVERY,
    labelKey: 'markDiscoveryComplete',
  },
  generate_level_framework: {
    type: LEVELING_AGENT_TOOL_TYPES.REASONING,
    labelKey: 'generateLevelFramework',
  },
  suggest_competencies: {
    type: LEVELING_AGENT_TOOL_TYPES.REASONING,
    labelKey: 'suggestCompetencies',
  },
  validate_level_structure: {
    type: LEVELING_AGENT_TOOL_TYPES.REASONING,
    labelKey: 'validateLevelStructure',
  },
  list_frameworks: {
    type: LEVELING_AGENT_TOOL_TYPES.READ,
    labelKey: 'listFrameworks',
  },
  list_departments: {
    type: LEVELING_AGENT_TOOL_TYPES.READ,
    labelKey: 'listDepartments',
  },
  list_divisions: {
    type: LEVELING_AGENT_TOOL_TYPES.READ,
    labelKey: 'listDivisions',
  },
  list_levels: {
    type: LEVELING_AGENT_TOOL_TYPES.READ,
    labelKey: 'listLevels',
  },
  export_leveling_framework: {
    type: LEVELING_AGENT_TOOL_TYPES.READ,
    labelKey: 'exportFramework',
  },
  create_full_framework: {
    type: LEVELING_AGENT_TOOL_TYPES.WRITE,
    labelKey: 'createFramework',
  },
  create_track: {
    type: LEVELING_AGENT_TOOL_TYPES.WRITE,
    labelKey: 'createTrack',
  },
  create_level: {
    type: LEVELING_AGENT_TOOL_TYPES.WRITE,
    labelKey: 'createLevel',
  },
  update_level: {
    type: LEVELING_AGENT_TOOL_TYPES.WRITE,
    labelKey: 'updateLevel',
  },
  delete_level: {
    type: LEVELING_AGENT_TOOL_TYPES.WRITE,
    labelKey: 'deleteLevel',
  },
};
